var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLoginTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 70,
    viewBox: "0 0 62 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5006_9466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7914 27.5941H54.0944L48.3336 32.4627V39.8038L53.4826 35.4196H53.7248L53.4444 51.8224C53.4444 52.6253 53.0238 53.3645 52.3356 53.7851C48.0915 56.3978 32.874 65.7399 31.0897 65.7399C29.0122 65.7399 27.3426 64.0575 27.3426 61.9929V38.0578C27.3426 35.1901 28.8848 32.5519 31.3828 31.15L58.4404 15.958L30.9495 0.689453L4.2742 15.4736C1.75069 16.8756 0.195801 19.5266 0.195801 22.4069V48.5724C0.195801 51.3508 1.68696 53.9125 4.09577 55.3017L25.5201 67.5879C29.2799 69.7418 33.9063 69.7163 37.6406 67.5242L58.0453 55.5057C60.3776 54.1292 61.8178 51.6184 61.8178 48.9165V29.6206C61.8178 28.5118 60.9129 27.6069 59.8041 27.6069L59.7914 27.5941Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5006_9466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.6093,
    height: 68.4916,
    fill: "white",
    transform: "translate(0.195312 0.689453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoginTransparent);
export default __webpack_public_path__ + "static/media/logo-login-transparent.7437c02cd54d2d6b2e39de486c71ec39.svg";
export { ForwardRef as ReactComponent };